import { ProfileOutlined } from "@ant-design/icons";
import { Button, type ButtonProps } from "antd";
import { useCallback } from "react";
import { useNavigate } from "react-router";

interface Props {
  script_id?: string;
  session_id?: string;
  btnProps?: ButtonProps;
}

export const ViewScriptResultBtn = (props: Props) => {
  const navigate = useNavigate();
  const { session_id, script_id, btnProps } = props;
  const handleClick = useCallback(() => {
    const params = new URLSearchParams();
    if (session_id) params.append('session_id', session_id);
    if (script_id) params.append('script_id', script_id);
    navigate(`/script-result?${params}`);
  }, [script_id, session_id]);
  return (
    <Button onClick={handleClick} {...btnProps}>
      <ProfileOutlined />
    </Button>
  )
}